import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Page from "../Page";
import Button from "../../components/input/button";
import useSubmitFeatureRequest from "../../hooks/feedback/useSubmitFeatureRequest";
import { Snackbar, Alert, Typography } from "@mui/material";

const RequestAFeaturePage = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [featureDescription, setFeatureDescription] = useState("");
  const [featureBenefit, setFeatureBenefit] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const { submit } = useSubmitFeatureRequest();

  const handleSubmit = async () => {
    if (!featureDescription.trim()) {
      setSnackbarMessage(
        "You must at least describe the feature you would like to see. The more information you can provide, the better chance we have of understanding your request.",
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setSubmitting(true);

    const result = await submit({
      featureDescription,
      featureBenefit,
    });

    setSubmitting(false);

    if (result.success) {
      setSnackbarMessage("Feature request submitted successfully. Thank you!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      // Clear form
      setFeatureDescription("");
      setFeatureBenefit("");
      // Navigate after a short delay to let user see the snackbar
      setTimeout(() => navigate("/feedback"), 1500);
    } else {
      setSnackbarMessage(
        `Failed to submit feature request. Please try again later`,
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  return (
    <Page className="feedback-page" pageKey="request-a-feature">
      <Typography variant="pageTitleWhite" className="feedback-page_title">
        Request a feature
      </Typography>

      <div className="feedback-page_panel">
        <Typography
          variant="formLabel"
          className="feedback-page_panel_input-label"
        >
          What would you like to see?
        </Typography>
        <textarea
          className="feedback-page_panel_input-area"
          placeholder="Please describe what feature you would like to see added to Mindstack."
          maxLength={2000}
          value={featureDescription}
          onChange={(e) => setFeatureDescription(e.target.value)}
        />

        <Typography
          variant="formLabel"
          className="feedback-page_panel_input-label"
        >
          Why would this benefit you?
        </Typography>
        <textarea
          className="feedback-page_panel_input-area"
          placeholder="Please describe why you think this feature would be beneficial to you and/or other users."
          maxLength={1000}
          value={featureBenefit}
          onChange={(e) => setFeatureBenefit(e.target.value)}
        />

        <Button
          color="orange"
          text="Submit feature request"
          size="large"
          onClick={handleSubmit}
          loading={submitting}
          disabled={submitting}
        />
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Page>
  );
};

export default RequestAFeaturePage;
